var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.Tasks),function(Task){return _c('h3',{key:Task.id},[_c('TodoTask',{attrs:{"Task":Task},on:{"toggle-reminder":function($event){return _vm.$emit('toggle-reminder', Task.id)},"delete-Task":function($event){return _vm.$emit('delete-Task', Task.id)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }